<template>
    <div>
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{$t('i18n.apk_update')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('i18n.apk_mange')}}</el-breadcrumb-item>
            <el-breadcrumb-item >
                <span v-on:click="back" size='mini'> {{$t('i18n.apk_version')}}</span>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="app-container">
            <el-card class="filter-container" shadow="never">

                <span style="padding-left:20px">
                    <el-col :span="3">
                        <el-input :placeholder="$t('i18n.column.version_search')" v-model="queryInfo.keywords" @keyup.enter.native="getApkVersionList" clearable @clear="getApkVersionList">
                            <el-button slot="append" icon="el-icon-search" @click="getApkVersionList"></el-button>
                        </el-input>
                    </el-col>
                    <el-button type="primary" round class="btn-add" @click="addVersion" size="mini">{{$t('i18n.app_version_add')}}</el-button>
                </span>
            </el-card>

            <!-- 添加APK版本的对话框 -->
            <el-dialog :title="$t('i18n.app_version_add')" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
                <!-- 内容主体区域 -->
                <el-form :model="addForm" v-if="addDialogVisible" :rules="addFormRules" ref="addFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.column.app_name')" prop="apkName" label-width="120px">
                        <el-input v-model="addForm.apkName" :disabled="true"> </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n.column.versionNo')" prop="versionNo" label-width="120px">
                        <el-input v-model="addForm.versionNo"> </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('i18n.column.description')" prop="dsc" label-width="120px">
                        <el-input type='textarea' v-model="addForm.dsc" :autosize="{ minRows: 10, maxRows: 80}"> </el-input>
                    </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">{{$t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="addOrUpdateVersion('addFormRef')">{{$t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>
        </div>

        <div class="table-container">
            <!-- table表格区域 -->
            <el-table :data="apkVersionList" border stripe>
                <el-table-column :label="$t('i18n.column.version_id')" width="80px" prop="id"></el-table-column>
                <el-table-column :label="$t('i18n.column.app_name')" prop="apkName" width="120px"></el-table-column>
                <el-table-column :label="$t('i18n.column.versionNo')" prop="versionNo"></el-table-column>
                <el-table-column :label="$t('i18n.column.create_time')" prop="createTime"></el-table-column>
                <el-table-column :label="$t('i18n.column.release_time')" prop="releaseTime"></el-table-column>
                <el-table-column :label="$t('i18n.column.file_name')" prop="fileName"></el-table-column>
                <el-table-column :label="$t('i18n.column.file_size')" prop="fileSize"></el-table-column>
                <el-table-column :label="$t('i18n.column.upload_install_package')">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status!=0">
                            <el-button type="primary" icon="el-icon-upload el-icon--right" round @click="handleUpLoadBigFile(scope.row)" size='mini'>{{ $t('i18n.upload') }}</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('i18n.column.download_url')" prop="downloadUrl">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.downloadUrl!=null && scope.row.downloadUrl.length>1 " :href="scope.row.downloadUrl" :underline="false" style="margin-left:15px">
                            <span>{{$t('i18n.column.download')}}</span>
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('i18n.column.version_status')" prop="status">
                    <template slot-scope="scope">
                        <span>{{computeStatus(scope.row.status)}}</span>
                    </template>

                </el-table-column>
                <el-table-column :label="$t('i18n.column.description')" :show-overflow-tooltip="true"	 prop="dsc"></el-table-column>
                <el-table-column :label="$t('i18n.column.operator')" width="260px">
                    <template slot-scope="scope">
                        <el-button type="danger" circle icon="el-icon-delete" size="mini" @click="handleDeleteVersion(scope.row)">
                        </el-button>
                        <el-button type="warning" round icon="el-icon-edit" size="mini" @click="editVersion(scope.row)">{{$t('i18n.update')}}</el-button>
                        <el-button v-if="scope.row.status===1" size="mini" type="info" round icon="el-icon-loading" disabled>{{$t('i18n.column.wait_upload')}}</el-button>
                        <el-button v-if="scope.row.status===2" size="mini" type="success" round @click="handleUpdateVersioStatus(scope.row,4)">{{$t('i18n.column.test_pass')}}</el-button>
                        <el-button v-if="scope.row.status===2" size="mini" type="warning" round @click="handleUpdateVersioStatus(scope.row,3)">{{$t('i18n.column.test_not_pass')}}</el-button>
                        <el-button v-if="scope.row.status===3" size="mini" type="warning" round disabled>{{$t('i18n.column.test_not_pass')}} </el-button>
                        <el-button v-if="scope.row.status===4" size="mini" type="danger" round @click="handleUpdateVersioStatus(scope.row,5)">{{$t('i18n.column.publish')}}</el-button>
                        <el-button v-if="scope.row.status===5" size="mini" type="danger" round @click="handleUpdateVersioStatus(scope.row,2)">{{$t('i18n.column.cancel_publish')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginnation-container">
            <!-- 分页区域 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNo" :page-sizes="[5, 10, 15, 20]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" background></el-pagination>
        </div>
    </div>
</template>

<script>
import { deleteVersion, apkVersionStatusUpdate } from '@/api/apkVersion';
const defaultListQuery = {
    pageNo: 1,
    pageSize: 15
};

export default {
    // inject: ['reload'], //注入reload方法刷新页面
    data() {
        return {
            // 查询参数对象
            apkList: [],
            apkVersionList: [],
            // 总数据条数
            totalSize: 0,
            queryInfo: Object.assign({}, defaultListQuery),
            // 控制添加APK版本对话框的显示与隐藏
            addDialogVisible: false,
            isEdit: false,
            // 添加APK版本的表单数据
            addForm: {
                apkVersionId: null,
                apkId: null,
                apkName: null,
                dsc: '',
                versionNo: ''
            },
            apkInfo: {
                apkId: null,
                apkName: null
            },
            // 添加表单的验证规则对象
            addFormRules: {
                apkId: [{ required: true, message: this.$t('i18n.validate.app_need'), trigger: 'blur' }],
                dsc: [{ required: true, message: this.$t('i18n.validate.description_need'), trigger: 'blur' }],
                versionNo: [{ required: true, message: this.$t('i18n.validate.versionNo_need'), trigger: 'blur' }]
            },
            updateVersion: {
                apkVersionId: null,
                useFlag: null,
                status: null
            }
        };
    },
    created() {
        this.getParam();
        this.getApkVersionList();
    },
    methods: {
        back() {
            this.$router.go(-1); //返回上一层
        },
        getParam() {
            this.queryInfo.apkId = this.$route.query.apkId;
            this.addForm.apkId = this.$route.query.apkId;
            this.addForm.apkName = this.$route.query.apkName;
        },
        addVersion() {
            this.isEdit = false;
            this.addDialogVisible = true;
            this.addForm.apkVersionId = null;
            this.addForm.versionNo = null;
            this.addForm.dsc = null;
        },
        editVersion(row) {
            this.addDialogVisible = true;
            this.isEdit = true;
            this.addForm.apkVersionId = row.id;
            this.addForm.versionNo = row.versionNo;
            this.addForm.dsc = row.dsc;
        },
        async getApkVersionList() {
            const { data: res } = await this.$http.get('/apk/apkVersionQueryPage', {
                params: this.queryInfo
            });
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.apkVersionList = res.data.list;
            this.totalSize = res.data.totalSize;
        },

        async addOrUpdateVersion() {
            const { data: res } = await this.$http.post(this.isEdit ? '/apk/apkVersionUpdate' : '/apk/apkVersionCreate', this.addForm);
            if (res.code !== 0) {
                this.$message.error(res.msg);
            } else {
                this.$message.success(this.$t('i18n.success'));
                this.$refs.addFormRef.resetFields();

                this.addDialogVisible = false;
                this.getApkVersionList();
            }
        },
        //修改状态
        async handleUpdateVersioStatus(row, status) {
            this.updateVersion.apkVersionId = row.id;
            this.updateVersion.status = status;
            const { data: res } = await apkVersionStatusUpdate(this.updateVersion);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.getApkVersionList();
        },

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getApkVersionList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNo = newPage;
            this.getApkVersionList();
        },
        async handleDeleteVersion(row) {
            console.log('----当前版本行------', row);
            const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText:  this.$t('i18n.confirm'),
                cancelButtonText:  this.$t('i18n.cancel'),
                type: 'warning'
            }).catch(err => {
                console.log('删除版本失败', err);
                return err;
            });

            if (confirmResult !== 'confirm') {
                return this.$message.info( this.$t('i18n.had_cancel_delete'));
            }
            const { data: res } = await deleteVersion(row.id);
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.getApkVersionList();
            this.$message.success(this.$t('i18n.success'));
        },

        // 监听添加APK版本对话框的关闭事件
        addDialogClosed() {
            this.$refs.addFormRef.resetFields();
        },

        handleEditVersion(row) {
            this.$router.push({ path: '/apkVersionUpdate', query: { versionId: row.versionId } });
        },
        computeStatus(status) {
            if (status == '0') {
                return this.$t('i18n.column.init_version');
            } else if (status == '1') {
                return this.$t('i18n.column.wait_upload');
            } else if (status == '2') {
                return this.$t('i18n.column.wait_test');
            } else if (status == '3') {
                return this.$t('i18n.column.test_not_pass');
            } else if (status == '4') {
                return this.$t('i18n.column.wait_publish');
            } else if (status == '5') {
                return this.$t('i18n.column.published');
            } else if (status == '6') {
                return this.$t('i18n.column.published');
            }
            return this.$t('i18n.column.wait_upload');
        },
        //文件上传
        handleUpLoadBigFile(param) {
            this.$router.push({
                path: '/apkUpload',
                query: {
                    versionNo: param.versionNo,
                    apkVersionId: param.id,
                    apkName: param.apkName
                }
            });
        }
    }
};
</script>

<style  scoped>
.el-pagination {
    text-align: right;
}
</style>
